exports = module.exports = require("../../../../../legacy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#form_search {\n  display: flex;\n}\n#form_search button {\n  min-width: 110px;\n  flex-grow: 0;\n}\n#form_search input[type=text] {\n  flex-grow: 1;\n}\n.city_search {\n  width: 700px;\n  max-width: 100%;\n  float: none;\n  margin: 0 auto;\n}\n.page-title {\n  font-size: 26px !important;\n}\n.page-title a {\n  font-size: 13px !important;\n}\n.ovf_row a {\n  font-weight: bold;\n  font-size: 13px;\n  top: 7px;\n  position: relative;\n}", ""]);

// exports
